import type { BannerTemplate } from '@/shared/api';

export interface RecommendedBannerTextLength {
  /** 메인 문구 권장 글자수 ({max} 안내에 사용) */
  main: number;
  /** 서브 문구 권장 글자수 (문구형만 양수, 그 외 0) */
  sub: number;
}

/**
 * 배너 템플릿별 권장 글자수.
 *
 * 백엔드 meta(`max_main_text_length`/`max_sub_text_length`)를 프론트에서 의도적으로
 * override 하는 값이다. 안내 문구의 `{max}` 표기에 사용되며, 서브 문구는 이 값이
 * 입력 maxLength 로도 강제된다(문구형 한정).
 */
const RECOMMENDED_BANNER_TEXT_LENGTH: Record<
  BannerTemplate,
  RecommendedBannerTextLength
> = {
  basic: { main: 25, sub: 0 },
  emphasis: { main: 20, sub: 0 },
  info: { main: 25, sub: 20 },
  image_heavy: { main: 25, sub: 0 },
};

export function getRecommendedBannerTextLength(
  template: BannerTemplate,
): RecommendedBannerTextLength {
  return RECOMMENDED_BANNER_TEXT_LENGTH[template];
}
